<template>
  <div class="loading"> </div>
</template>

<script>
  import { mapState } from 'vuex'
  import actions from '@/store/action-types'
  
  export default {
    name: 'loading',
    computed: {
      ...mapState({
        externalChannels: state => state.activity.externalChannels,
        joined: state => state.activity.joined,
        activityStatus: state => state.activity.activityStatus
      })
    },
    created () {
      if (!this.externalChannels) {
        this.$store.dispatch(actions.fetch.ACTIVITY_STATUS).then(() => {
          if (this.activityStatus === 1 && this.joined) {
            this.$router.replace('donate')
            // this.$store.dispatch(actions.fetch.USER_INFORMATION)
          } else {
            this.$router.replace('landing')
          }
        })
      } else {
        this.$router.replace('landing')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Loading.vue?6bae030c